import React from "react";
 import { TestiMonials } from "./Containt_home";
    
const Solution = ()=>{
    return <div>
    <h1>Solution</h1>
      <TestiMonials />;
    </div>
}
export default Solution;